module.exports = __webpack_public_path__ + "img/facial_recognition_error.d68a9f9c.svg";